// import { Box, Text, theme } from "@aksara-ui/react";
import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import RaffleActivityContent from "modules/RaffleActivity";
import React from "react";

import { setTitle } from "utilities/helper/setTitle";
const RaffleActivityPage: React.FC = () => {
  setTitle("Raffle Activity");
  return (
    <Auth>
      <Layout>
        <RaffleActivityContent />
      </Layout>
    </Auth>
  );
};

export default RaffleActivityPage;
